import type { ModalTypeWithProps } from '~/modal/modalRegistry.type';

export const isModalTypeWithProps = (modalInfo: ModalTypeWithProps): modalInfo is ModalTypeWithProps => {
  return !Array.isArray(modalInfo);
};
